import { LokiRoutes } from "./loki.routes";
import { LokiFilterService } from "./loki.filter.service";
import { OrganizationSearchFilter } from "./organizations/organization-search.filter";
import "./loki.search.service";
import "./advanced-search/loki-advanced-search.component";
import "./advanced-search/filter.site.component";
import "./advanced-search/filter.organization.component";
import "./send-to-wp-button/send-to-wp-button.component";
import "../shared/published-icons-list/published-icons-list.component";

angular.module("loki", [
    "thor.loki.search.service",
    "thor.loki.advanced-search.component",
    "thor.loki.filter.site.component",
    "thor.loki.filter.organization.component",
    "thor.loki.send-to-wp-button.component",
    "thor.shared.published-icons-list.component"
])
    .service("lokiFilterService", LokiFilterService)
    .filter("organizationSearchFilter", <any>OrganizationSearchFilter)
    .config(LokiRoutes);
